module.exports = __webpack_public_path__ + "static/media/AdminPrenomina.eb5837e9.svg";